import {
  Layout,
  Button,
  Typography,
  Tooltip,
  Row,
  Col,
  Menu
} from "antd";
import { ArrowLeftOutlined, ContainerOutlined, SettingOutlined } from "@ant-design/icons";

import React, { useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import useRoleCheck from "utilities/hooks/roleCheck";
import config from "config";

const { Header, Content } = Layout;
const { Title, Text } = Typography;

const AppLayout = () => {
  const { hasPermission } = useRoleCheck();

  const location = useLocation();
  const navigate = useNavigate();

  const [currentKey, setCurrentKey] = useState(location.pathname.includes("/admin") ? "admin" : "applications");

  const items = [
    {
      label: 'Applications',
      key: 'applications',
      icon: <ContainerOutlined />,
      onClick: () => navigate("/applications"),
    },
    {
      label: 'Admin',
      key: 'admin',
      icon: <SettingOutlined />,
      onClick: () => navigate("/admin"),
    }
  ];

  return (
    <Layout style={{ height: "100vh", flexDirection: "column" }}>
      <Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: 64,
          backgroundColor: "#0F2B54",
        }}
      >
        <Row align="middle" gutter={16}>
          <Tooltip title="Back to Clinic Central">
            <Button
              type="text"
              onClick={() => window.location.href = config.clinicCentralUrl}
              style={{ padding: 0, margin: 0 }}
            >
              <Text type="secondary" style={{ fontSize: "30px" }}>
                <ArrowLeftOutlined style={{ color: '#FFFFFF' }} />
              </Text>
            </Button>
          </Tooltip>
          <img
            src="/HLBubbleWhite.svg"
            alt="logo"
            style={{ maxHeight: "60px", marginRight: "0.5rem", marginLeft: "1rem" }}
          />
          <Title level={2} style={{ margin: 0, color: "#FFFFFF" }}>CFBH App</Title>
        </Row>
      </Header>
      {hasPermission(["Admin.Manage", "Audiology"]) && (
        <Menu
          selectedKeys={[currentKey]}
          mode="horizontal"
          items={items}
          onClick={(e) => setCurrentKey(e.key)}
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      )}
      <Content style={{ flex: 1, height: "100%" }}>
        <Outlet />
      </Content>
    </Layout>
  )
};

export default AppLayout;